// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getDocument = (name: string, path: string) => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');
//  const params = { name, path: path.replace(/\\/g, '/') };
const params = { name, path };

  return backendAxios.get('/documents', { params, responseType: 'blob' });
};

export default getDocument;
